import { ReactNode } from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * 主题 Provider 组件
 * 
 * 基于 next-themes 的主题 Provider，提供完整的主题管理功能。
 * 
 * 功能：
 * - 初始化主题系统
 * - 监听系统主题变化
 * - 自动同步主题到 HTML 元素（通过 `.dark` 类）
 * - 防止主题闪烁（FOUC）
 * 
 * 使用方式：
 * ```tsx
 * <ThemeProvider>
 *   <App />
 * </ThemeProvider>
 * ```
 * 
 * 参考：https://ui.shadcn.com/docs/theming
 */
/** 支持的主题列表：浅色、深色、深蓝暗色。传入后 next-themes 才会正确持久化与切换自定义主题 */
const THEMES = ['light', 'dark', 'theme-dark-blue'] as const;

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange={false}
      themes={[...THEMES]}
    >
      {children}
    </NextThemesProvider>
  );
}

